"use client";

import { excludeGenerate } from "../services/migration/excludeGenerate";

interface UseExcludeGenerate {
  generateExcludeApi: (migrationId: string, xaccountid: string, apiId: string | any) => Promise<any>;
}

/**
 * Hook generate exclude
 */
export function useExcludeGenerate(): UseExcludeGenerate {
  const generateExcludeApi = async (migrationId: string, xAccountId: string | any, apiId: string) => {
    try {
      const response = await excludeGenerate(migrationId, xAccountId, apiId);
      if (response.content && response.status === 200) {
        return response;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    generateExcludeApi,
  };
}
